<ng-container class="featureInfo">
  <div class="header-container">
    <h3 class="igo-panel-title">{{ 'legend.legendButton' | translate }}</h3>
    <button
      class="clear-button sideresult-closed"
      mat-icon-button
      igoStopPropagation
      (click)="clearButton()"
      color="primary"
    >
      <mat-icon svgIcon="close"></mat-icon>
    </button>
  </div>
  <div class="radius"></div>

  <div class="table-container">
    <table>
      <tr>
        <td class="circle-container">
          <span class="circle z-royal-blue"></span>
        </td>
        <td class="text-container">
          Direction immobilière de l'Abitibi-Témiscamingue et du Nord-du-Québec
        </td>
      </tr>
      <tr>
        <td class="circle-container">
          <span class="circle z-lime-green"></span>
        </td>
        <td class="text-container">
          Direction immobilière du Bas-Saint-Laurent et de la
          Gaspésie-Îles-de-la-Madeleine
        </td>
      </tr>
      <tr>
        <td class="circle-container"><span class="circle z-crimson"></span></td>
        <td class="text-container">
          Direction immobilière du centre-ville de Montréal
        </td>
      </tr>
      <tr>
        <td class="circle-container"><span class="circle z-gold"></span></td>
        <td class="text-container">
          Direction immobilière du centre-ville de Québec
        </td>
      </tr>
      <tr>
        <td class="circle-container">
          <span class="circle z-dim-gray"></span>
        </td>
        <td class="text-container">
          Direction immobilière de l'Estrie et de la Montérégie
        </td>
      </tr>
      <tr>
        <td class="circle-container"><span class="circle z-tomato"></span></td>
        <td class="text-container">
          Direction immobilière de Laval, des Laurentides et de Lanaudière
        </td>
      </tr>
      <tr>
        <td class="circle-container">
          <span class="circle z-medium-purple"></span>
        </td>
        <td class="text-container">
          Direction immobilière de la Mauricie et du Centre-du-Québec
        </td>
      </tr>
      <tr>
        <td class="circle-container">
          <span class="circle z-dark-olive-green"></span>
        </td>
        <td class="text-container">
          Direction immobilière du Nord de Montréal
        </td>
      </tr>
      <tr>
        <td class="circle-container">
          <span class="circle z-medium-turquoise"></span>
        </td>
        <td class="text-container">Direction immobilière du Nord de Québec</td>
      </tr>
      <tr>
        <td class="circle-container">
          <span class="circle z-dark-red"></span>
        </td>
        <td class="text-container">Direction immobilière de l'Outaouais</td>
      </tr>
      <tr>
        <td class="circle-container"><span class="circle z-cyan"></span></td>
        <td class="text-container">
          Direction immobilière du Saguenay-Lac-Saint-Jean et la Côte-Nord
        </td>
      </tr>
      <tr>
        <td class="circle-container">
          <span class="circle z-peach-puff"></span>
        </td>
        <td class="text-container">Direction immobilière du Sud de Montréal</td>
      </tr>
      <tr>
        <td class="circle-container">
          <span class="circle z-dark-slate-gray"></span>
        </td>
        <td class="text-container">Direction immobilière du Sud de Québec</td>
      </tr>
      <!--
      <tr>
        <td class="circle-container"><span class="circle z-medium-orchid"></span></td>
        <td class="text-container">Autre</td>
      </tr>
  -->
    </table>
  </div>
</ng-container>
